import React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { HeadTransaction } from '~/types/HeadTransaction';
import CustomModule from '~/modules';

import ReversalAction from './ReversalAction';
import ApprovalAction from './ApprovalAction';
import CancelAction from './CancelAction';
import RefundRejectedAction from './RefundRejectedAction';
import DecryptVoucherCodeAction from './DecryptVoucherCodeAction';
import DecryptSecureCodeAction from './DecryptSecureCodeAction';

interface Props {
  transaction: HeadTransaction;
  history?: any;
}

const Actions = (props: Props) => {
  const { transaction, history } = props;
  const classes = useStyles();

  return (
    <Grid item xs={6} className={classes.actions}>
      <CancelAction transaction={transaction} history={history} />
      <ReversalAction transaction={transaction} history={history} />
      <ApprovalAction transaction={transaction} history={history} />
      <RefundRejectedAction transaction={transaction} history={history} />
      <DecryptVoucherCodeAction transaction={transaction} />
      <DecryptSecureCodeAction transaction={transaction} />
      <CustomModule name='ExportInvoice' headTransaction={transaction} />
    </Grid>
  );
};

const useStyles = makeStyles((theme) => ({
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
  },
}));

export default Actions;
